module.exports = __webpack_public_path__ + "static/scale-model-of-lippitt-house-museum-in-providence-rhode-island-4f028e2c0001e8c0deaa33b11d74131a.png";